<template>
<div>
  <v-list class='mb-4 pb-0' >
    <v-subheader >{{ $t('subheaders.current') }}</v-subheader>
    <template v-for='(version, index) in versions' >
      <v-subheader
        :key='`sh-${version.VersionId}`'
        v-if='index === 1' >
        {{ $t('subheaders.older') }}
      </v-subheader>
      <v-subheader
        :key='`sh-${version.VersionId}`'
        v-if='version.StorageClass === "GLACIER" && index > 0 && versions[index-1].StorageClass !== "GLACIER"' >
        {{ $t('subheaders.archived') }}
      </v-subheader>
      <v-list-tile
        :key='`tile-${version.VersionId}`'
        :disabled='version.StorageClass === "GLACIER"' >
        <v-list-tile-action >
          <v-btn
            v-if='version.StorageClass !== "GLACIER"'
            :href='version.url'
            target='_blank'
            icon
            class='ml-1' ><v-icon>cloud_download</v-icon></v-btn>
          <v-icon v-else small disabled class='ml-2' >fiber_manual_record</v-icon>
        </v-list-tile-action>

        <v-list-tile-content >
          <v-list-tile-title>
            {{ dateformat(version.LastModified) }}
          </v-list-tile-title>
          <v-list-tile-sub-title>
            {{ dateformat(version.LastModified, 'HH:mm a') }}
          </v-list-tile-sub-title>
        </v-list-tile-content>

        <v-list-tile-action
          v-if='version.IsLatest' >
          <v-icon color='success' class='mr-2' >check</v-icon>
          <v-list-tile-action-text >
            Latest
          </v-list-tile-action-text>
        </v-list-tile-action>

      </v-list-tile>
      <v-divider :key='`div-${version.VersionId}`' ></v-divider>
    </template>
    <v-progress-linear
      v-if='loading'
      indeterminate :height="2" class='ma-0' >
    </v-progress-linear>
  </v-list>
  <v-footer >
    <span class='px-3' >
      Please note versions can take a few minutes to update
    </span>
  </v-footer>
</div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'InvoiceVersions',
  props: {
    invoice: { type: Object, required: true },
    touch: { type: Number, default: 0 }
  },
  data () {
    return {
      loading: false,
      versions: []
    }
  },
  methods: {
    getVersions () {
      let url = this.$invoiceguru.baseUrl + '/invoices/' + this.invoice.id + '/files/'
      let options = this.$invoiceguru.getOptions()
      let vm = this
      vm.loading = true
      axios.get(url, options)
        .then((data) => {
          vm.versions = data.data.versions
        })
        .finally(() => {
          vm.loading = false
        })
    }
  },
  watch: {
    touch: {
      immediate: true,
      handler () {
        this.getVersions()
      }
    }
  },
  i18n: {
    messages: {
      en: {
        subheaders: {
          current: 'Current version',
          older: 'Older versions',
          archived: 'Archived versions'
        }
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// InvoiceVersions.vue?7fb72bae